// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  agmkey: 'AIzaSyB3sPVtGDa1JEh5Fhaiq8i5Fw5QRraZvzY'
};



// WEBPACK FOOTER //
// /Users/enzo/Desktop/capsycofr-angular/src/environments/environment.ts